/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Fetch_JobsInputs */

const en_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const de_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const fr_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const es_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const it_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const nl_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const pl_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const fi_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const da_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

const sv_portal_scanner_fetch_jobs = /** @type {(inputs: Portal_Scanner_Fetch_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch Jobs`)
};

/**
* | output |
* | --- |
* | "Fetch Jobs" |
*
* @param {Portal_Scanner_Fetch_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_fetch_jobs = /** @type {((inputs?: Portal_Scanner_Fetch_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Fetch_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_fetch_jobs(inputs)
	if (locale === "fr") return fr_portal_scanner_fetch_jobs(inputs)
	if (locale === "es") return es_portal_scanner_fetch_jobs(inputs)
	if (locale === "it") return it_portal_scanner_fetch_jobs(inputs)
	if (locale === "nl") return nl_portal_scanner_fetch_jobs(inputs)
	if (locale === "pl") return pl_portal_scanner_fetch_jobs(inputs)
	if (locale === "fi") return fi_portal_scanner_fetch_jobs(inputs)
	if (locale === "da") return da_portal_scanner_fetch_jobs(inputs)
	if (locale === "sv") return sv_portal_scanner_fetch_jobs(inputs)
	return en_portal_scanner_fetch_jobs(inputs)
});